export const FORGOT_PASSWORD_RESET = 'FORGOT_PASSWORD_RESET'
export const FORGOT_PASSWORD_SET_ERROR = 'FORGOT_PASSWORD_SET_ERROR'
export const FORGOT_PASSWORD_SET_VIOLATIONS = 'FORGOT_PASSWORD_SET_VIOLATIONS'
export const FORGOT_PASSWORD_TOGGLE_LOADING = 'FORGOT_PASSWORD_TOGGLE_LOADING'
export const FORGOT_PASSWORD_SET_SENT = 'FORGOT_PASSWORD_SET_SENT'
